import image1 from '../../assets/programs/academic_visits/image1.webp'
import image2 from '../../assets/programs/academic_visits/image2.webp'
import image3 from '../../assets/programs/academic_visits/image3.webp'

const academic_visits_data = {
    "title": "Academic Visits",
    "description": " The ONI Cell fosters global connections by engaging with international students through collaborative projects, cultural exchanges, academic interactions, and joint workshops. This initiative strengthens IIT Delhi's global presence and enriches the learning experience for all participants.",
    "content": [
        {
            "primaryHeading": "International",
            "subContent": [
                {
                    "secondaryHeading": "IIT Delhi and Shin Edupower host high school students from Japan",
                    "description": "IIT Delhi hosted 40 students from Japan and India, where Dr. Akash, a member of IHFC, led an engaging robotics workshop featuring TOTO, an autonomous mobile robot.",
                    "images": [
                        {
                            "src": image1,
                            "desc": "Dr. Akash with the high school students"
                        }
                    ]
                },
                {
                    "secondaryHeading": "University of Tokyo students interaction at IIT Delhi",
                    "description": "University of Tokyo students visited IIT Delhi, engaging in scholarship presentations, strengthening academic ties and showing potential for international collaboration.",
                    "images": [
                        {
                            "src": image2,
                            "desc": "University of Tokyo students at the presentation"
                        }
                    ]
                }
            ]
        },
        {
            "primaryHeading": "National",
            "subContent": [
                {
                    "secondaryHeading": "High school students from Rewari visit IIT Delhi",
                    "description": "High school students from Rewari visited IIT Delhi for a tour, which included a session with IHFC members, a showcase of innovative projects, and a visit to the Axlr8r club.",
                    "images": [
                        {
                            "src": image3,
                            "desc": "The visiting students at the project showcase"
                        }
                    ]
                }
            ]
        }
    ]
}

export default academic_visits_data;